import React from "react";
import { useTranslation } from "react-i18next";
import { Copy } from "lucide-react";
import toast from "react-hot-toast";

const TRC20_ADDRESS = "TB4k7a8RmVw3Hd5ERLDnxK84jiDTaPiUdw";

const TelegramIcon = ({ className }) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    aria-hidden="true"
  >
    <path d="M9.78 18.65l.28-4.23 7.68-6.92c.34-.31-.07-.46-.52-.19L7.74 13.3 3.64 12c-.88-.25-.89-.86.2-1.3l15.97-6.16c.73-.33 1.43.18 1.15 1.3l-2.72 12.81c-.19.91-.74 1.13-1.5.71L12.6 16.3l-1.99 1.93c-.23.23-.42.42-.83.42z" />
  </svg>
);

const Support = () => {
  const { t } = useTranslation();

  const handleCopyAddress = async () => {
    try {
      await navigator.clipboard.writeText(TRC20_ADDRESS);
      toast.success(t("support.tether.copiedToast"));
    } catch (err) {
      toast.error(t("support.tether.copyFailed"));
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">
          {t("support.title")}
        </h1>
        <p className="text-gray-500 text-sm mt-1">{t("support.subtitle")}</p>
      </div>

      <div className="flex flex-col lg:flex-row gap-6 items-stretch pt-8">
        {/* Telegram card — vertical layout */}
        <a
          href="https://t.me/nasprobotadmin"
          target="_blank"
          rel="noopener noreferrer"
          className="group block w-full lg:w-auto bg-white rounded-2xl shadow-sm border border-gray-200 p-10 hover:shadow-lg transition-all text-center"
        >
          <div className="flex justify-center mb-6">
            <div className="w-24 h-24 rounded-full bg-[#0088cc] flex items-center justify-center shadow-lg group-hover:shadow-xl transition-shadow">
              <TelegramIcon className="w-14 h-14 text-white" />
            </div>
          </div>

          <h2 className="text-3xl font-bold text-gray-900 mb-2">Telegram</h2>
          <p className="text-lg text-gray-500">{t("support.handle")}</p>
        </a>

        {/* tether USDT card */}
        <div className="w-full lg:w-auto bg-white rounded-2xl shadow-sm border border-gray-200 p-6 hover:shadow-lg transition-all flex flex-col items-center text-center max-w-xs">
          <h2 className="text-xl font-bold text-gray-900 mb-1">Tether</h2>
          <p className="text-sm text-gray-500 mb-4">USDT (TRC20)</p>

          <div className="w-44 h-44 rounded-xl border border-gray-200 p-2 bg-white mb-3">
            <img
              src="/teyter-qr.png"
              alt="tether USDT TRC20 QR Code"
              className="w-full h-full object-contain"
              onError={(e) => {
                if (e.currentTarget.dataset.fallback !== "1") {
                  e.currentTarget.dataset.fallback = "1";
                  e.currentTarget.src = "/no_image.webp";
                }
              }}
            />
          </div>

          <code className="text-xs text-gray-700 font-mono break-all bg-gray-50 px-3 py-2 rounded-md border border-gray-200 mb-3 select-all w-full">
            {TRC20_ADDRESS}
          </code>

          <button
            type="button"
            onClick={handleCopyAddress}
            className="btn-secondary flex items-center gap-2"
          >
            <Copy className="w-4 h-4" />
            {t("support.tether.copyButton")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Support;
